<template>
	<section class="hero-section">
		<Row class="relative z-[2]">
			<Container
				class="flex min-h-[572px] flex-wrap lg:flex-nowrap lg:flex-row flex-col items-center"
			>
				<div
					class="flex w-full max-w-[660px] lg:max-w-[600px] xl:max-w-[720px] flex-col gap-[32px] mx-auto lg:mx-0 lg:top-[-32px] relative"
				>
					<h1
						id="hero-title"
						class="gradient-title-white text-center lg:text-left"
					>
						Make Smart Trades From Almost Anywhere
					</h1>

					<div
						id="hero-lead-capture-form"
						class="flex flex-col gap-[32px] items-center lg:items-start"
					>
						<h3
							id="hero-subtitle"
							class="text-lg text-white max-w-[600px] text-center lg:text-left"
						>
							StocksToTrade goes beyond simply combining the top fundamental and
							technical tools on the internet.
						</h3>
						<div class="test">
							<CtaButton
								to="https://cfn.stockstotrade.com/try-stt1"
								:blank="true"
							>
								14-day StocksToTrade trial — only $7
							</CtaButton>
						</div>
						<JoinPitch
							id="hero-join-pitch"
							:is-white="true"
						/>
					</div>
				</div>
				<div
					class="hero-image-container mt-[32px] mb-[164px] lg:my-[64px] lg:w-1/2 lg:my-0"
				>
					<GradientBorderBlock
						parent-class="platform-embed !rounded-[14px]"
						class="!rounded-[12px]"
					>
					<iframe
						title="top-gainers-iframe"
						src="https://master.d2xx6vtf6inrnz.amplifyapp.com/small-grid?quote_page=1"
						width="260"
						height="278"
						frameborder="0"
						loading="lazy"
					></iframe>
					</GradientBorderBlock>
					<div class="plagform-image-block">
						<img
							width="720"
							height="552"
							src="/images/platform-image-1.webp"
							alt=""
							class="md:min-w-[720px] !rounded-[14px]"
						/>
					</div>
				</div>
			</Container>
		</Row>
	</section>
</template>

<script setup>
import anime from "animejs";

useIframeQuoteListener();

const breakpoints = reactive(
	useBreakpoints({
		small: 768
	})
);

onMounted(() => {
	if (import.meta.client) {
		const textWrapper = document.querySelector(".gradient-title-white");
		const scale_value = breakpoints.isGreater("small") ? [1, 1] : [0.75, 0.75];
		textWrapper.innerHTML = textWrapper.textContent.replace(
			/\S/g,
			"<span class='letter'>$&</span>"
		);

		anime
			.timeline()
			.add({
				targets: "#hero-title",
				opacity: [0, 1],
				easing: "easeInOutQuad",
				duration: 10
			})
			.add({
				targets: "#hero-title .letter",
				opacity: [0, 1],
				easing: "easeInOutQuad",
				duration: 500,
				delay: (el, i) => 10 * (i + 1)
			})
			.add({
				targets: "#hero-lead-capture-form",
				opacity: [0, 1],
				easing: "easeInOutQuad",
				translateY: [25, 0],
				duration: 500
			});

		anime({
			targets: ".plagform-image-block",
			easing: "easeInOutQuad",
			opacity: [0, 1],
			translateX: [800, 0],
			duration: 500
		});

		anime({
			targets: ".platform-embed",
			easing: "easeInOutQuad",
			opacity: [0, 1],
			translateX: [800, 0],
			scale: scale_value,
			duration: 500,
			delay: 250
		});
	}
});
</script>
<style lang="scss" scoped>
@use "~/assets/utils.scss" as *;
.plagform-image-block {
	opacity: 0;
}
#hero-lead-capture-form {
	opacity: 0;
	transform: translateY(25);
}
.hero-image-container {
	position: relative;
	margin-left: auto;
	margin-right: auto;
	// height: 636px;
	// width: 700px;
	max-width: 585px;
	@include breakpoint(lg) {
		max-width: unset;
	}
}

@media (min-width: 1024px) and (max-width: 1280px) {
	.hero-image-container {
		// transform: scale(0.7);
	}
}

.platform-embed {
	position: absolute;
	left: 0;
	right: 0;
	margin: auto;
	outline: 6px solid rgba($white, 0.05);
	z-index: 2;
	bottom: -200px;
	max-width: 264px;

	@include breakpoint(lg) {
		top: -64px;
		min-width: 264px;
		opacity: 0;
		left: 52px;
		margin-left: 0;
		bottom: unset;
		transform: translateX(800);
	}
}

h1#hero-title {
	opacity: 0;
}
h1#hero-title .letter {
	opacity: 0;
}

.fade-in {
	opacity: 0; /* Initially invisible */
	animation: fadeInAnimation 500ms ease-in forwards 2s; /* Animation properties with a delay of 500ms */
}

@keyframes fadeInAnimation {
	from {
		opacity: 0; /* Starting opacity */
	}
	to {
		opacity: 1; /* Ending opacity */
	}
}

.swoosh-mobile {
	position: relative;
	z-index: 2;

	.swoosh {
		top: 0;
	}
}
</style>
